import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Portfolio } from "@/components/Portfolio";
import { Services } from "@/components/Services";
import { Pricing } from "@/components/Pricing";
import IntakeForm from "@/components/intake/IntakeForm";
import { Footer } from "@/components/Footer";
import { GridLines, SectionDivider } from "@/components/GridLines";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-[#090A0F] min-h-screen">
      <GridLines />
      <Navbar />
      <main>
        <Hero />
        <SectionDivider />
        <Portfolio />
        <SectionDivider />
        <Services />
        <SectionDivider />
        <Pricing />
        <SectionDivider />
        <IntakeForm />
      </main>
      <Footer />
    </div>
  );
}
